import React, { useEffect, useState } from "react";

import ReactTable from "react-table";
import { getHeaders } from "../../helpers/getHeaders";
import queryString from "query-string";

import ArrowLeft from "../../images/ic-arrow-left.svg";
import ArrowRight from "../../images/ic-arrow-right.svg";
import axios from "../../axios-instance";
import NewLoader from "../NewLoader/NewLoader";

const columns = [
  {
    Header: "Event",
    accessor: "eventName",
  },
  {
    Header: "Ticket",
    accessor: "ticketTemplateName",
  },
  {
    Header: "Ticket Amount",
    accessor: "totalTicketsSold",
  },
  {
    Header: "Orders",
    accessor: "totalTransactions",
  },
];

const pageSize = 6;

export const TicketsSales = () => {
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState({
    total: 0,
  });
  const [loading, setLoading] = useState(false);

  const getData = async () => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));
    const params = {
      page: pageNumber,
      pageSize,
    };
    const queryParams = queryString.stringify(params, { encode: false });

    const { data } = await axios.get(`/Events/EventsStats?${queryParams}`, {
      headers: getHeaders(user.token),
    });

    setData(data);
    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, [pageNumber]);

  const handlePage = (action) => {
    switch (action) {
      case "next":
        const totalPages = Math.ceil(data.total / pageSize);
        if (totalPages >= pageNumber + 1) {
          setPageNumber(pageNumber + 1);
        }
        break;
      case "previous":
        if (pageNumber - 1) {
          setPageNumber(pageNumber - 1);
        }
        break;
      default:
        break;
    }
  };

  return (
    <div className="dashboard__tickets-sales">
      <div className="dashboard__card-header">
        <h6 className="dashboard__title">Tickets Sales</h6>
        <div className="dashboard__actions">
          <button
            className="dashboard__actions-btn"
            onClick={() => handlePage("previous")}
          >
            <img src={ArrowLeft} alt="Minus Time" />
          </button>
          <p>
            {pageNumber} / {Math.ceil(data.total / pageSize)}
          </p>
          <button
            className="dashboard__actions-btn"
            onClick={() => handlePage("next")}
          >
            <img src={ArrowRight} alt="Add Time" />
          </button>
        </div>
      </div>
      {loading ? (
        <NewLoader />
      ) : (
        <ReactTable
          resizable={false}
          showPagination={false}
          sortable={false}
          data={data.list}
          pageSize={pageSize}
          columns={columns}
        />
      )}
    </div>
  );
};
